module.exports = __webpack_public_path__ + "fonts/MyriadPro-Cond.a411116.woff";